import React from 'react';
import { LocationNameHeading } from './styles';
import { node } from 'prop-types';

/**
 * Non-clickable version of LocationName component for ploc locations
 */
function NonClickableLocationName({ children }) {
  return (
    <LocationNameHeading data-testid="MapCardNonClickableLocationName">
      {children}
    </LocationNameHeading>
  );
}

NonClickableLocationName.propTypes = {
  children: node.isRequired
};

export default NonClickableLocationName;
